import styled from 'styled-components/macro'

import {
  Field,
  Toggle,
  ToggleGroup,
  type ToggleGroupProps,
  type ToggleGroupChangeEventDetail,
} from '@loadsmart/miranda-react'

import { type DerivedShipmentStatus } from '../../domain/AgnosticShipmentFilter'

const StyledField = styled(Field)`
  width: 100%;
  min-width: none;
`

const StyledToggleGroup = styled(ToggleGroup)`
  width: 100%;
  min-width: 256px;
  inline-size: auto;
`

type StatusToggleProps = Omit<ToggleGroupProps, 'onChange'> & {
  value?: Array<DerivedShipmentStatus>
  onChange?: (value: Array<DerivedShipmentStatus>) => void
}

export function StatusToggle({ value, onChange, style, ...rest }: StatusToggleProps) {
  function handleChange(event: CustomEvent<ToggleGroupChangeEventDetail>) {
    onChange?.(event.detail.value as unknown as Array<DerivedShipmentStatus>)
  }

  return (
    <StyledField style={style}>
      <Field.Label id="status-label-filter">Status</Field.Label>
      <StyledToggleGroup
        type="multiple"
        value={value}
        onChange={handleChange}
        {...rest}
        aria-labelledby="status-filter-label"
      >
        <Toggle value="upcoming">Upcoming</Toggle>
        <Toggle value="ongoing">Ongoing</Toggle>
        <Toggle value="past">Past</Toggle>
      </StyledToggleGroup>
    </StyledField>
  )
}
